import { render, staticRenderFns } from "./PWABannerGrid.vue?vue&type=template&id=22bea525&scoped=true"
import script from "./PWABannerGrid.vue?vue&type=script&lang=js"
export * from "./PWABannerGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bea525",
  null
  
)

export default component.exports